import { Injectable } from '@angular/core';

import { HttpAgent } from '@ag-ui/client';
import type { BaseEvent, RunAgentInput } from '@ag-ui/core';
import { Observable } from 'rxjs';

import {
  injectTellentAssistantActorGetter,
  injectTellentAssistantAuthTokenGetter,
  injectTellentAssistantEndpoint,
} from './tellent-assistant-endpoint.provider';

@Injectable({ providedIn: 'root' })
export class TellentAssistantAguiClient {
  private readonly endpoint = injectTellentAssistantEndpoint();
  private readonly getToken = injectTellentAssistantAuthTokenGetter();
  private readonly getActor = injectTellentAssistantActorGetter({ optional: true }) ?? (() => null);

  public run(input: RunAgentInput): Observable<BaseEvent> {
    const token = this.getToken();
    const actor = this.getActor();
    // The token getter returns the full Authorization header value (e.g. "Bearer eyj...").
    // Don't prepend a scheme — that would produce "Bearer Bearer ..." → backend 403.
    const headers: Record<string, string> = {};
    if (token) headers['Authorization'] = token;
    if (actor) headers['x-ts-actor'] = actor;
    const agent = new HttpAgent({
      url: this.endpoint,
      headers,
    });
    return new Observable<BaseEvent>(subscriber => {
      const subscription = agent.run(input).subscribe({
        next: event => subscriber.next(event),
        error: err => subscriber.error(err),
        complete: () => subscriber.complete(),
      });
      return () => subscription.unsubscribe();
    });
  }
}
